:host {
  display: block;
}

dialog {
  border: none !important;
  border-radius: var(--klevu-border-radius-m);
  padding: 0;
  box-shadow: var(--klevu-elevation-1);
}

main {
  padding: var(--klevu-spacing-04);
}

header {
  padding: var(--klevu-spacing-04);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button {
  border: none;
  background-color: transparent;
  appearance: none;
  border-radius: 100%;
  height: 30px;
  width: 30px;
}
